import { cache } from 'react';

export type RegionLocale = 'msk' | 'spb';

export const REGIONS: RegionLocale[] = ['msk', 'spb'];

const DEFAULT_LOCALE: RegionLocale = 'msk';
const MSK_HOST = process.env.NEXT_PUBLIC_MSK_HOST ?? 'pgscom.ru';
const SPB_HOST = process.env.NEXT_PUBLIC_SPB_HOST ?? 'spb.pgscom.ru';

export const REGION_HOSTS: Record<RegionLocale, string> = {
  msk: MSK_HOST,
  spb: SPB_HOST,
};

export const resolveLocale = (host: string): RegionLocale => (host.startsWith(SPB_HOST) ? 'spb' : DEFAULT_LOCALE);

export const getRegionFromRequest = (request: Request): RegionLocale => {
  const host = request.headers.get('x-forwarded-host') ?? request.headers.get('host') ?? '';
  return resolveLocale(host);
};

export interface RegionParams {
  region: string;
}

export const parseRegion = (region: string): RegionLocale | null =>
  (REGIONS as string[]).includes(region) ? (region as RegionLocale) : null;

const getServerRegionLocale = cache(async (): Promise<RegionLocale> => {
  try {
    const { headers } = await import('next/headers');
    const host = (await headers()).get('host') ?? '';
    return resolveLocale(host);
  } catch {
    return DEFAULT_LOCALE;
  }
});

export async function getRegionLocale(): Promise<RegionLocale> {
  if (typeof window !== 'undefined') {
    return resolveLocale(window.location.hostname);
  }

  return getServerRegionLocale();
}
